import React, {useEffect, useState} from 'react'
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";


// components
import SpaFormComponent from "../forms/SpaFormComponent";
import ParkFormComponent from "../forms/ParkFormComponent";
import SpecialFormComponent from "../forms/SpecialFormComponent";
import ActivityFormComponent from "../forms/ActivityFormComponent";
import RestaurantFormComponent from "../forms/RestaurantFormComponent";
import TransportationFormComponent from "../forms/TransportationFormComponent";

//actions
import { setItem } from "../../../redux/actions/generalActions/formActions";

// utils
import { getWishlistOption, getWishlistOptions, wishlistTypes } from "../../../util/WishlistUtils";
import {LB_WL_ACTIVITY} from "../../i18n/i18n";

const ModalNewItem = props => {
    const { isOpen, wishlist, handleToggle } = props
    const { domainObject } = props.formState
    const { listDomainObjects } = props.listState

    const [selectedOption, setSelectedOption] = useState( getWishlistOption() )
    const [showSpecials, setShowSpecials] = useState( true )
    const options = getWishlistOptions()

    useEffect( () => {
        if(!domainObject) {
            setSelectedOption(getWishlistOption(wishlistTypes.default))

            return
        }

        setSelectedOption(getWishlistOption(wishlistTypes[domainObject?.type?.toLowerCase()]))
    },[domainObject] )

    const handleSelectOption = (type = wishlistTypes.default) => {
        setSelectedOption( getWishlistOption(type) )
        props.setItem( null )
    }

    useEffect(() => {
        const selectedWishlist = listDomainObjects?.find( l => l?.id === wishlist?.id)

        if(!selectedWishlist)
            return

        const special = selectedWishlist?.components?.find( c => c?.type == wishlistTypes.special.description )

        setShowSpecials( !special )
    },[listDomainObjects])

    return <Modal
        isOpen={ isOpen }
        centered={ true }
        unmountOnClose={ true }
        onClosed={()=>handleSelectOption( wishlistTypes.default )}
        toggle={ handleToggle }
        className={`wl-modal ${ (selectedOption?.default || selectedOption?.type == wishlistTypes?.special )? 'wl-modal-select-option' : 'wl-modal-form' }`}
    >
        <ModalBody className={'wl-modal-body'}>
            {
                selectedOption?.default && <div className={'wl-modal-title'}>
                    {selectedOption?.title}
                </div>
            }
            <div className={ selectedOption?.default ? 'wl-modal-new-item-container' : ''}>
                {
                    selectedOption?.default
                        ?  options.map((option, index) => {
                            if((!showSpecials && option?.type == wishlistTypes.special) || !option?.enabled)
                                return

                            return <div
                                key={index}
                                className={`wl-modal-new-card ${option?.enabled ? 'wl-modal-new-card-enabled' : 'wl-modal-new-card-disabled' }`}
                                onClick={ () => {
                                    if(!option?.enabled)
                                        return

                                    handleSelectOption(option?.type)
                                } }
                            >
                                <div className={'wl-modal-new-card-icon'}>
                                    <img
                                        src={require(`../../../assets/images/wishlist/${option?.icon}`)}
                                        alt={LB_WL_ACTIVITY}
                                        width={48}
                                        height={48}
                                    />
                                </div>
                                <div className={'wl-modal-new-card-label'}>
                                    {option?.title}
                                </div>
                            </div>
                        })
                        : function(){
                            switch (selectedOption?.type){
                                case wishlistTypes.transportation:
                                    return <TransportationFormComponent
                                        wishlist={wishlist}
                                        selectedOption={ selectedOption }
                                        handleToggle={ handleToggle }
                                        handleCancel={ handleToggle }
                                    />
                                case wishlistTypes.spa:
                                    return <SpaFormComponent
                                        wishlist={wishlist}
                                        selectedOption={ selectedOption }
                                        handleToggle={ handleToggle }
                                        handleCancel={ handleToggle }
                                    />
                                case wishlistTypes.afi:
                                    return <ParkFormComponent
                                        wishlist={wishlist}
                                        selectedOption={selectedOption}
                                        handleToggle={ handleToggle }
                                        handleCancel={ handleToggle }
                                    />
                                case wishlistTypes.restaurant:
                                    return <RestaurantFormComponent
                                        wishlist={wishlist}
                                        selectedOption={ selectedOption }
                                        handleToggle={ handleToggle }
                                        handleCancel={ handleToggle }
                                    />
                                case wishlistTypes.activity:
                                    return <ActivityFormComponent
                                        wishlist={wishlist}
                                        selectedOption={ selectedOption }
                                        handleToggle={ handleToggle }
                                        handleCancel={ handleToggle }
                                    />
                                case wishlistTypes.special:
                                    return <SpecialFormComponent
                                        wishlist={wishlist}
                                        selectedOption={ selectedOption }
                                        handleToggle={handleToggle}
                                        handleCancel={handleToggle}
                                    />

                                default:
                                    return
                            }
                        }()
                }
            </div>
        </ModalBody>
    </Modal>
}

const mapStateToProps = state => ({
    formState: state.formProps,
    listState: state.listProps
})
const mapActionsToProps = ({ setItem })

export default connect(mapStateToProps, mapActionsToProps)(ModalNewItem)